import React from "react";
import { Button as MuiButton, CircularProgress } from "@mui/material";
import { styled } from "@mui/system";

// Styled Button Component
const StyledButton = styled(MuiButton)(({ theme, variant }) => ({
  backgroundColor: variant === "contained" ? "#203C00" : "transparent",
  color: variant === "contained" ? "#FFFFFF" : "#203C00",
  fontSize: "16px",
  fontWeight: "bold",
  textTransform: "none",
  borderRadius: "8px",
  padding: "10px 20px",
  width: "100%",
  marginTop: "20px",
  "&:hover": {
    backgroundColor: "#1A3100",
    color: "#FFFFFF",
  },
  border: "1px solid #203C00",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledCircularProgress = styled(CircularProgress)(({ variant }) => ({
  color: variant === "contained" ? "#FFFFFF" : "#203C00",
}));

const Button = ({
  label,
  onClick,
  variant = "contained",
  disabled = false,
  loading = false, // Added loading prop
}) => {
  return (
    <StyledButton
      variant={variant}
      onClick={onClick}
      disabled={disabled || loading} // Disable when loading
    >
      {loading ? <StyledCircularProgress size={24} variant={variant} /> : label}
    </StyledButton>
  );
};

export default Button;
